import { AppEnv } from './app-env';
import { TreatmentScanType } from 'app/core/enums';
import { SampleOrderDesignSimulation } from './sample-order-design-simulation.model';

const sampleOrderDesignSimulation: SampleOrderDesignSimulation = {
  enabled: true,
  message: 'Your files are ready for approval.',
  mockDesigner: {
    userId: 'auth0|68ad82f4e6d9335b482fa0b7',
    name: 'Elias Designer',
  },
  designFiles: [
    {
      scanType: TreatmentScanType.UpperJaw,
      fileGuid: 'd7a70348-4713-445a-bff1-b2ba4abff615',
      filename: 'patients/d7a70348-4713-445a-bff1-b2ba4abff615.stl',
      fileSize: 21512384,
      fileType: '.stl',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.LowerJaw,
      fileGuid: '5288381c-161b-4edb-b7ad-07bab13d2eb5',
      filename: 'patients/5288381c-161b-4edb-b7ad-07bab13d2eb5.stl',
      fileSize: 18352584,
      fileType: '.stl',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '8509e45a-a736-48f2-85fa-35f8dae55bc2',
      filename: 'patients/8509e45a-a736-48f2-85fa-35f8dae55bc2.stl',
      fileSize: 1552684,
      fileType: '.stl',
      teeth: '13',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '1758b444-548b-46ee-bd98-e3302162528b',
      filename: 'patients/1758b444-548b-46ee-bd98-e3302162528b.stl',
      fileSize: 1063984,
      fileType: '.stl',
      teeth: '12',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '568028d4-33ba-42c5-be77-0cec4d917a5b',
      filename: 'patients/568028d4-33ba-42c5-be77-0cec4d917a5b.stl',
      fileSize: 1114984,
      fileType: '.stl',
      teeth: '11',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '7f9c5baa-4655-4a0a-9d04-4149b1e71770',
      filename: 'patients/7f9c5baa-4655-4a0a-9d04-4149b1e71770.stl',
      fileSize: 869434,
      fileType: '.stl',
      teeth: '10',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: 'e13035c8-b897-42dc-838b-be3c6849a043',
      filename: 'patients/e13035c8-b897-42dc-838b-be3c6849a043.stl',
      fileSize: 1403084,
      fileType: '.stl',
      teeth: '8',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '06554f24-cc9f-48c7-9c55-685279533e3c',
      filename: 'patients/06554f24-cc9f-48c7-9c55-685279533e3c.stl',
      fileSize: 802884,
      fileType: '.stl',
      teeth: '9',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '78c166c1-026f-43e5-b7da-99c73adb6c00',
      filename: 'patients/78c166c1-026f-43e5-b7da-99c73adb6c00.stl',
      fileSize: 1381834,
      fileType: '.stl',
      teeth: '7',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '274ce109-08ad-45e3-a011-bd486ae38d16',
      filename: 'patients/274ce109-08ad-45e3-a011-bd486ae38d16.stl',
      fileSize: 928234,
      fileType: '.stl',
      teeth: '6',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: 'e6fb2d4a-b4be-44af-9f39-54f0d916dca2',
      filename: 'patients/e6fb2d4a-b4be-44af-9f39-54f0d916dca2.stl',
      fileSize: 1279934,
      fileType: '.stl',
      teeth: '5',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: 'd8e45699-ad1b-4036-9448-1a0339eae6a7',
      filename: 'patients/d8e45699-ad1b-4036-9448-1a0339eae6a7.stl',
      fileSize: 848584,
      fileType: '.stl',
      teeth: '4',
      subGroup: '',
    },
  ],
};

export const environment = {
  production: true,
  apiBaseUrl: 'https://api.getneer.com/api/',
  apiSprintRayBaseUrl: 'https://staging-neer.sprintray.com/api/v2/',
  appBaseUrl: 'https://dashboard.getneer.com/', // TODO: Update to production URL (e.g. https://dashboard.getneer.com/) when going live
  appAccounts: 'https://staging.account.sprintray.com',
  appEnv: AppEnv.prod,
  sprintRayChatLink: 'https://staging-chat.sprintray.com',

  appSyncRegion: 'us-west-2',
  appSyncGraphQLEndpoint: 'https://wlsyxtct4vgkzbfpakkf5rjfzq.appsync-api.us-west-2.amazonaws.com/graphql',

  printPreviewBucketUrl: 'https://s3-us-west-1.amazonaws.com/print-preview-image',
  platformScreenshotBucketUrl: 'https://sprint-ray-files-prod.s3.us-west-2.amazonaws.com/delta',
  axionTrainingLink: 'https://sprintray.axiomtrainingcloud.com/',
  store: 'https://store.sprintray.com',
  storePrint: 'https://store.sprintray.com/shop/product-category?cat=114&tag=',
  sprintrayCommunity: 'https://community.sprintray.com/',
  sprintray3DViewerUrl: 'https://3dviewer.designservice.sprintray.com?t=1723457975',
  cloudDriveUrl: 'https://dashboard.sprintray.com/cloud-drive/embed?connection=neer',
  neerPrivacyUrl: 'https://www.getneer.com/pages/privacy-and-terms',

  launchDarkly: {
    clientKey: '69af77c2dafb3a0a10085986',
  },
  googleMap: {
    apiKey: 'AIzaSyAF4ZK1WB8Qgx6tn6vq9o47QUpzWip7beM',
    mapId: 'f316a13183a1590f3e69ec41',
    apiUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
  },
  stripe: {
    paymentMethodConfigurationId: 'pmc_1R0GjOFThULfMuJ9TUqm1Liv',
    buyButtonId: 'buy_btn_1SuranFThULfMuJ9fuyqOefE',
    moment5PackPriceId: 'price_1SufTrFThULfMuJ9rkvHbo5P',
  },

  auth0: {
    clientID: 'TEcQrIPvPlSHWNANq0WrFHrj8iSfdEUZ',
    domain: 'auth.getneer.com',
    audience: 'https://dev-wepiguwfil37608i.us.auth0.com/api/v2/',
    scope: 'openid email profile',
    responseType: 'token id_token',
  },

  _3shape: {
    clientID: 'Sprintray',
    domain: 'identity.3shape.com',
    scope: 'openid api offline_access communicate.connections.manage data.companies.read_only data.users.read_only',
    responseType: 'code',
    authorizePath: 'connect/authorize',
  },

  // Change to Prod values, when available
  medit: {
    clientID: '5YfJHOwHUYhhB0cv1Qx5SdZ7nSH4hpyd',
    domain: 'stage-openapi-developers.meditlink.com',
    scope: 'USER GROUP CASE FILE',
    responseType: 'code',
    authorizePath: 'oauth/authorize',
  },

  itero: {
    clientID: 'BCKr9mtBHB6bp5WLs1BRbLODDNQa',
    domain: 'identity-cus.aligntech.com',
    scope: 'openid',
    responseType: 'code',
    authorizePath: 'oauth2/authorize',
  },

  cloudDriveExternalProviders: {
    medit: {
      clientId: 'VN54iYDvyEypU44D53oPfIu8OcDHnXUt',
      name: 'Medit',
    },
    _3shape: {
      clientId: 'oAjxVxH0ZGfBf6iOpoRs6M5OPCAq803K',
      name: '3Shape',
    },
    _3shapeDesktop: {
      clientId: '7xdg8TOuQpKKGyBam5KUEUrLf3cRDX1C',
      name: '3Shape Desktop',
    },
    dexis: {
      clientId: 'oDcOt91L5UflGDFNu87YY33aEDRI0pbr',
      name: 'Dexis',
    },
    exocad: {
      clientId: '6nYGwLJwfAQ3UqtU4OSyG1fJpx3CQH4r',
      name: 'Exocad',
      disabled: false,
    },
    envista: {
      clientId: 'cLEsJITqA4iwCsmLbo7QUwwsypQsO7hi',
      name: 'Envista',
    },
    Itero: {
      clientId: 'N/A',
      name: 'iTero',
    },
  },

  organizationIds: {
    aspen: 'c7623ead-5d22-4413-aea7-2d0674727bd4',
    pacific: '90126234-b738-4780-a424-f10545f11b1f',
    pds: '90126234-b738-4780-a424-f10545f11b1f',
    neer: '5097037e-c102-4325-ac9f-b6bded20ce5a',
  },
  aicad: {
    url: 'https://ai-cad.designservice.sprintray.com/index.html#/',
    apiBaseUrl: 'https://flbb81b96d.execute-api.us-west-2.amazonaws.com/prod',
  },
  studio: {
    url: 'https://ai-cad.designservice.sprintray.com/studio/index.html',
  },
  connections: {
    sprintRay: {
      auth0Connection: 'SprintRay',
    },
  },
  sampleOrderDefaults: {
    treatmentType: 'Neer',
    upperJawScanFile: {
      fileGuid: 'aa34d142-a78a-472e-8754-a9cb6b655967',
      filename: 'patients/aa34d142-a78a-472e-8754-a9cb6b655967.ply',
      fileSize: 12802484,
      fileType: 'ply',
      subGroup: '',
    },
    lowerJawScanFile: {
      fileGuid: '0a03a138-4411-4c28-8c43-214c53134b18',
      filename: 'patients/0a03a138-4411-4c28-8c43-214c53134b18.ply',
      fileSize: 9665551,
      fileType: 'ply',
      subGroup: '',
    },
    biteScanFile: {
      fileGuid: 'a68fd92d-aedd-430e-9d66-98e584eeb67c',
      filename: 'patients/a68fd92d-aedd-430e-9d66-98e584eeb67c.ply',
      fileSize: 2559284,
      fileType: 'ply',
      subGroup: '',
    },
    frontSmileScanFile: {
      fileGuid: '37b0afb9-1e4f-441a-8c7d-4639a623b025',
      filename: 'patients/37b0afb9-1e4f-441a-8c7d-4639a623b025.jpg',
      fileSize: 66393,
      fileType: 'jpg',
      subGroup: '',
    },
  },
  sampleOrderDesignSimulation,
};
